import script from "./DataDokumenteFirma.vue?vue&type=script&setup=true&lang=js"
export * from "./DataDokumenteFirma.vue?vue&type=script&setup=true&lang=js"

import "./DataDokumenteFirma.vue?vue&type=style&index=0&id=77475fb5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77475fb5"]])

export default __exports__